module.exports = [{
      plugin: require('D:/projects/gandalfTheBlue/node_modules/gatsby-remark-autolink-headers/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/projects/gandalfTheBlue/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-130227707-1"},
    },{
      plugin: require('D:/projects/gandalfTheBlue/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    }]
